const LOGIN_STATE_KEY = 'login_state';
const LOGIN_PENDING_KEY = 'login_pending';
const ACCOUNT_LINK_SELECTOR = 'a.header__icon--account, a.menu-drawer__account';

class LoginSuccessToast extends HTMLElement {
  constructor() {
    super();
    this.autoHideTimer = null;
    this.pollTimer = null;
    this.onCloseClick = this.hide.bind(this);
    this.hasShown = false;
  }

  connectedCallback() {
    this.closeButton = this.querySelector('.login-success-toast__close');
    this.closeButton?.addEventListener('click', this.onCloseClick);

    const wasLoggedOut = sessionStorage.getItem(LOGIN_STATE_KEY) === 'logged_out';

    this.syncLoginState();
    this.bindLoginTriggers();

    if (this.isLoggedIn) {
      this.updateAccountLinks();
      if (wasLoggedOut) {
        this.show();
      }
      this.cleanUrl();
      return;
    }

    if (sessionStorage.getItem(LOGIN_PENDING_KEY) === 'true') {
      // this.startLoginPolling();
    }
  }

  disconnectedCallback() {
    this.closeButton?.removeEventListener('click', this.onCloseClick);
    window.clearTimeout(this.autoHideTimer);
    window.clearInterval(this.pollTimer);
  }

  get isLoggedIn() {
    return this.dataset.customerLoggedIn === 'true';
  }

  get accountUrl() {
    return this.dataset.accountUrl || '/account';
  }

  get loginUrl() {
    return this.dataset.loginUrl || '/account/login';
  }

  syncLoginState() {
    if (this.isLoggedIn) {
      sessionStorage.setItem(LOGIN_STATE_KEY, 'logged_in');
      sessionStorage.removeItem(LOGIN_PENDING_KEY);
      return;
    }

    sessionStorage.setItem(LOGIN_STATE_KEY, 'logged_out');
  }

  markLoginPending() {
    sessionStorage.setItem(LOGIN_STATE_KEY, 'logged_out');
    sessionStorage.setItem(LOGIN_PENDING_KEY, 'true');
    this.startLoginPolling();
  }

  bindLoginTriggers() {
    document.querySelectorAll('form[action*="login"]').forEach((form) => {
      form.addEventListener('submit', () => this.markLoginPending());
    });

    document.addEventListener(
      'click',
      (event) => {
        if (this.isLoggedIn) return;

        const target = event.target.closest(
          `${ACCOUNT_LINK_SELECTOR}, shopify-app-block, [class*="otp"], [id*="otp"], [data-otp], [class*="social-login"], [class*="google-login"]`
        );

        if (!target) return;

        // Send Google Analytics event for login click
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'login_click');
        }

        // this.markLoginPending();
      },
      true
    );

    window.addEventListener('login:success', () => this.completeLogin());
    document.addEventListener('storefront:signincompleted', () => this.completeLogin());
  }

  startLoginPolling() {
    if (this.isLoggedIn) return;

    window.clearInterval(this.pollTimer);

    let attempts = 0;
    this.pollTimer = window.setInterval(async () => {
      attempts += 1;

      if (attempts > 30) {
        window.clearInterval(this.pollTimer);
        sessionStorage.removeItem(LOGIN_PENDING_KEY);
        return;
      }

      const loggedIn = await this.fetchLoggedInStatus();
      if (!loggedIn) return;

      window.clearInterval(this.pollTimer);
      this.completeLogin();
    }, 2000);
  }

  async fetchLoggedInStatus() {
    if (this.isLoggedIn) {
      return true;
    }

    try {
      const response = await fetch('/account', {
        credentials: 'same-origin',
        redirect: 'manual',
      });

      return response.status === 200;
    } catch {
      return false;
    }
  }

  completeLogin() {
    sessionStorage.setItem(LOGIN_STATE_KEY, 'logged_in');
    sessionStorage.removeItem(LOGIN_PENDING_KEY);

    if (this.dataset.customerLoggedIn !== 'true') {
      window.location.reload();
      return;
    }

    this.updateAccountLinks();
    this.show();
  }

  updateAccountLinks() {
    document.querySelectorAll(ACCOUNT_LINK_SELECTOR).forEach((link) => {
      link.href = this.accountUrl;
    });
  }

  show() {
    if (this.hasShown) return;

    this.hasShown = true;

    // Send Google Analytics event for successful login
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'login_success');
    }

    this.removeAttribute('hidden');

    requestAnimationFrame(() => {
      this.classList.add('active');
    });

    window.clearTimeout(this.autoHideTimer);
    this.autoHideTimer = window.setTimeout(() => this.hide(), 5000);
  }

  hide() {
    this.classList.remove('active');
    window.clearTimeout(this.autoHideTimer);

    window.setTimeout(() => {
      this.setAttribute('hidden', '');
    }, 400);
  }

  cleanUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('login_success')) return;

    url.searchParams.delete('login_success');
    const search = url.searchParams.toString();
    const nextUrl = url.pathname + (search ? `?${search}` : '') + url.hash;
    window.history.replaceState({}, '', nextUrl);
  }
}

customElements.define('login-success-toast', LoginSuccessToast);
